import {
  Box,
  Button,
  Grid,
  TextField,
  Modal,
  ToggleButton,
  ToggleButtonGroup,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
} from "@mui/material";
import React, { useState } from "react";
import "./FinancialGoals.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setProductClass,
  setAnswers,
} from "../../features/FPSlice/financialPageSlice";
import Logo from "../../images/logo_quick-learning-tool.png";
import DaniloEng from "../../images/danilo-ipon_english-ver.png";
import LanieEng from "../../images/lanie-hiram_english-ver.png";
import PedroEng from "../../images/pedro-segurado_english-ver.png";
import { CancelRounded } from "@mui/icons-material";
import Swal from "sweetalert2";

function FinancialGoals() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [inputValues, setInputValues] = useState({});
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedLang, setSelectedLang] = useState("english");

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue);
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleNext = () => {
    if (!selectedValue) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Fields",
        text: "Please complete all required fields to proceed",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      return;
    }

    const requiredFields = {
      savings: ["savingsQ1", "savingsQ2"],
      loan: ["loanQ1", "loanQ2", "loanQ3"],
      insurance: ["insuranceQ1", "insuranceQ2"],
      others: ["otherQ1"],
    };

    const fieldsToCheck = requiredFields[selectedValue];

    if (
      !inputValues.mainQuestion ||
      fieldsToCheck.some((field) => !inputValues[field])
    ) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Fields",
        text: "Please complete all required fields to proceed",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      return;
    }

    dispatch(setProductClass(selectedValue));
    dispatch(setAnswers(inputValues));
    navigate("/avatar/En");
  };

  const handleKeyPress = (e) => {
    const lowercaseKey = e.key.toLowerCase();

    if (lowercaseKey !== e.key) {
      e.preventDefault();
    }

    if (e.key === ".") {
      e.preventDefault();
    }
  };

  const handleLanguage = () => {
    navigate("/Fil");
  };

  return (
    <Box>
      <Box className="main-card">
        <Grid container>
          <Grid item xs={12} md={3} className="left-card">
            <Box className="img-container">
              <img src={Logo} alt="Logo" className="logo-img" />
            </Box>
            <Box sx={{ margin: "1rem" }}>
              <Button
                sx={{
                  backgroundColor: "#06BCEE",
                  color: "#ffffff",
                  textTransform: "none",
                  padding: ".5rem",
                  width: "100%",
                  borderRadius: "2rem",
                  fontSize: "1.2rem",
                  "&:hover": {
                    backgroundColor: "#06BCEE", // Set it to the same value as the default
                  },
                }}
                onClick={() => handleLanguage()}
              >
                To Filipino Ver.
              </Button>
            </Box>
            <Box className="instruction-card">
              <p className="instruction-title">Activity Instructions</p>
              <p className="instruction-text">
                An empowered customer has a defined financial goal associated
                with a dream to become financially independent.
              </p>
              <p className="instruction-text">
                S/he has a plan of action that identifies the needed amount and
                financial product/s to pursue the goal.
              </p>
              <p className="instruction-text">
                Take the Avatar Making exercise to help you set a financial goal
                and determine the financial product you will need.
              </p>
            </Box>
          </Grid>
          <Grid item xs={12} md={9} className="right-card">
            <Box className="fgMain-card">
              <Box sx={{ padding: "1rem" }}>
                <h1 style={{ fontSize: "2.5rem", padding: "1rem" }}>
                  Do you have a financial goal?
                </h1>
                <p className="link-text" onClick={() => handleOpen()}>
                  See sample answers
                </p>
                <Box className="main-question-card">
                  <Box className="question-card">
                    <p className="english-text">
                      Within two years, what do you hope to achieve financially?
                    </p>
                    <TextField
                      variant="standard"
                      name="mainQuestion"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      className="textField"
                      placeholder="Type your answer here..."
                      onChange={handleChangeInput}
                      onKeyPress={handleKeyPress}
                    />
                  </Box>
                  <Box className="question-card">
                    <p className="english-text">
                      What financial product will you use to help you realize
                      your financial goal?
                    </p>
                    <Box
                      display="flex"
                      flexDirection="row"
                      sx={{ marginTop: "1rem" }}
                    >
                      <ToggleButtonGroup
                        value={selectedValue}
                        exclusive
                        onChange={handleChange}
                        fullWidth
                      >
                        <ToggleButton value="savings" className="root">
                          Savings
                        </ToggleButton>
                        <ToggleButton value="loan" className="root">
                          Loan
                        </ToggleButton>
                        <ToggleButton value="insurance" className="root">
                          Insurance
                        </ToggleButton>
                        <ToggleButton value="others" className="root">
                          Others
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                  </Box>
                  {selectedValue === "savings" && (
                    <>
                      <Box className="question-card">
                        <p className="english-text">
                          How much savings do you want?
                        </p>

                        <TextField
                          variant="standard"
                          name="savingsQ1"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="Type your answer here..."
                          onChange={handleChangeInput}
                          type="number"
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                      <Box className="question-card">
                        <p className="english-text">
                          How much can you save per month?
                        </p>

                        <TextField
                          variant="standard"
                          name="savingsQ2"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="Type your answer here..."
                          onChange={handleChangeInput}
                          type="number"
                          onKeyDown={handleKeyPress}
                        />
                      </Box>
                    </>
                  )}
                  {selectedValue === "loan" && (
                    <>
                      <Box className="question-card">
                        <p className="english-text">
                          What is the purpose of your loan?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="Type your answer here..."
                          name="loanQ1"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                      <Box className="question-card">
                        <p className="english-text">
                          How much do you want to borrow?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="Type your answer here..."
                          name="loanQ2"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                          type="number"
                        />
                      </Box>
                      <Box className="question-card">
                        <p className="english-text">
                          In your opinion, how long will it take you to pay
                          this?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="Type your answer here..."
                          name="loanQ3"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                    </>
                  )}
                  {selectedValue === "insurance" && (
                    <>
                      <Box className="question-card">
                        <p className="english-text">
                          What kind of insurance do you want?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="Type your answer here..."
                          name="insuranceQ1"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                      <Box className="question-card">
                        <p className="english-text">
                          How much is this total premium or premium per month?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="Type your answer here..."
                          name="insuranceQ2"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                          type="number"
                        />
                      </Box>
                    </>
                  )}
                  {selectedValue === "others" && (
                    <>
                      <Box className="question-card">
                        <p className="english-text">Please specify</p>
                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="Type your answer here..."
                          name="otherQ1"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            </Box>
            <Box className="button-container">
              <Button className="next-button" onClick={() => handleNext()}>
                Next
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Modal open={open} onClose={handleClose} className="fgExample-main">
        <Box className="fgExample-modal">
          <Grid container>
            <Grid item xs={12}>
              <CancelRounded
                sx={{
                  float: "right",
                  fontSize: 45,
                  color: "#D9D9D9",
                  marginTop: "-.5rem",
                  cursor: "pointer",
                }}
                onClick={() => handleClose()}
              />
            </Grid>
            {selectedLang === "english" && (
              <>
                <Grid item xs={12} md={4}>
                  <Box className="img-container">
                    <img
                      src={DaniloEng}
                      alt="example"
                      className="example-img"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="img-container">
                    <img src={LanieEng} alt="example" className="example-img" />
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="img-container">
                    <img src={PedroEng} alt="example" className="example-img" />
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}

export default FinancialGoals;
